/**
 * Project: academy-v2
 * File: ListeningExercise
 * Author: wanpeninsula
 * Author URI: https://www.pennycodes.dev
 * Created: 30/01/2024 at 7:00 pm
 *
 * Copyright (c) 2024 academy-v2. All rights reserved.
 */
import { SpinnerLoader } from "@/components/ui/Loader.tsx";
import AnswerSheet from "@/components/v3/exercises/AnswerSheet.tsx";
import { ExerciseType } from "@/components/v3/exercises/ExerciseBadge";
import { useUserExercises } from "@/data/exercises.ts";
import ExerciseLayout from "@/layouts/ExerciseLayout.tsx";
import { useNavigate, useParams } from "react-router-dom";
const BASE = import.meta.env.EDS_BASE_URL;

function ListeningExercise() {
  const { id } = useParams();
  const navigate = useNavigate();
  const { exercises, isLoading } = useUserExercises();
  const exercise = exercises?.toDo.find((e) => e.token == id!);

  return (
    <ExerciseLayout
      type={ExerciseType.LISTENING}
      audioSrc={
        exercise?.files?.audio
          ? `${BASE}/v1/ielts/audio/stream/${exercise?.token}`
          : ""
      }
      // title={"⚠️ " + t("exercises.listening_title")}
      title={exercise?.name}
      onClose={() => navigate(-1)}
      exercise={exercise}
    >
      {isLoading ? (
        <div className="flex items-center justify-center w-full h-full">
          <SpinnerLoader className={"!h-12 !w-12 border-t-light"} />
        </div>
      ) : (
        <AnswerSheet exercise={exercise} id={exercise ? exercise.id : 0} />
      )}
    </ExerciseLayout>
  );
}

export default ListeningExercise;
